import React from 'react';

import { CountDown } from '../common/countdown/CountDown.component';
import styles from './Auction.module.css';

interface Props {
  hasEnded: boolean;
  isLive: boolean;
  startDate: Date;
}

export const BidSchedule = ({ hasEnded, isLive, startDate }: Props) => {
  if (hasEnded) {
    return (
      <div className={styles.auctionDescriptionAlign}>
        <div className={styles.auctionDescriptionHeader}>auction ended</div>
        <div className={styles.auctionDescription}>
          Stay tuned for our next NFT auction with Rob Prior and his Star Wars
          NFT
        </div>
      </div>
    );
  }

  if (isLive) {
    return (
      <div className={styles.auctionDescriptionAlign}>
        <div className={styles.auctionDescriptionHeader}>now live</div>
        <div className={styles.auctionDescription}>
          Join Mogul and Rob Prior for the first ever auction of a provably
          original painting turned into an NFT
        </div>
      </div>
    );
  }

  return (
    <div className={styles.auctionDescriptionAlign}>
      <div className={styles.auctionDescriptionHeader}>auction begins in</div>
      <CountDown date={startDate} />
    </div>
  );
};
